<template>
    <div>
        <table-actions-menu>
            <edit-button :url="route('tenant.clients.user-groups.show', {client: data.client_id, user_group: data.id})"></edit-button>

            <link-table-action-button :url="route('tenant.clients.user-groups.users.index', {client: data.client_id, user_group: data.id})" :label="trans('buttons.users')">
                <inline-svg
                    :url="require('../../../../images/actions/users-group.svg')"
                    classes="table-action-cell__icon"
                >
                </inline-svg>
            </link-table-action-button>

            <link-table-action-button :url="route('tenant.clients.user-groups.courses.index', {client: data.client_id, user_group: data.id})" :label="trans('buttons.courses')">
                <inline-svg
                    :url="require('../../../../images/actions/course.svg')"
                    classes="table-action-cell__icon"
                >
                </inline-svg>
            </link-table-action-button>

            <delete-button
                :url="route('tenantapi.clients.user-groups.destroy', {client: data.client_id, user_group: data.id})"
                :confirmTitle="this.trans('user_groups.note.delete_title')"
                :confirmText="this.trans('user_groups.note.delete_message')"
                :deleteId="data.id"
            ></delete-button>
        </table-actions-menu>
    </div>
</template>

<script>
    import InlineSvg from '../../../util/inlineSvg.js'
    import EditButton from '../../table_actions/table_actions_buttons/EditButton.vue';
    import DeleteButton from '../../table_actions/table_actions_buttons/DeleteButton.vue';

    export default {
        props: ['data', 'index'],

        components: {
            EditButton,
            DeleteButton,
            InlineSvg
        },
    }
</script>
